export default __webpack_public_path__ + "static/stile_x_timelapse-c1974cfce6d0201cc6a739fb53167439.mp4";